export const cleanMinimalATS = {
  id: 'clean-minimal-ats',
  version: 2,
  renderer: 'enterprise',
  name: 'Clean Minimal ATS',
  layout: 'single-column',
  theme: 'slate-executive',
  persona: ['software', 'backend', 'engineering', 'consulting'],
  atsLevel: 'A+',
  scoreWeights: {
    ats: 50,
    visual: 15,
    executive: 15,
    student: 20
  },
  sectionOrder: ['personal-info', 'summary', 'experience', 'projects', 'education', 'skills'],
  components: {
    header: 'header-classic',
    experience: 'experience-compact',
    projects: 'projects-list',
    skills: 'skills-simple-list',
    education: 'education-compact'
  },
  metadata: {
    industry: ['Tech Giants', 'Professional Services', 'Consulting'],
    companies: ['Google', 'Meta', 'Amazon', 'Microsoft', 'Accenture', 'Deloitte'],
    ats: ['Workday', 'Taleo', 'Lever', 'Greenhouse'],
    pages: { min: 1, max: 2, preferred: 1 },
    photo: false,
    icons: false,
    density: 'comfortable',
    columns: 1,
    experienceLevel: ['Entry-level', 'Mid-level', 'Senior'],
    careerStage: 'Professional',
    recommendedFor: ['Software Developers', 'Systems Administrators', 'Technical Analysts'],
    avoidFor: ['Creative Designers', 'Photographers', 'Art Directors'],
    dna: ['Minimalist-Clean', 'ATS-Maximal', 'High-Readability', 'Inter-Sans', 'Standard-Padding'],
    metrics: {
      readingDifficulty: 99,
      scanningSpeed: 99,
      visualAppeal: 82
    },
    hiringManager: {
      firstImpression: "Extremely tidy, simple, and straightforward technical professional",
      scanningStyle: "Rapid vertical scan focusing on clear section dividers and experience details",
      preferredStructure: "Summary, experience, skills, projects, education",
      dislikes: ["Wall of text paragraphs", "Graphics or icons", "Overly decorative lines"]
    },
    strategy: {
      goal: "Provide a 100% clean, standard single-column layout for perfect ATS parsing",
      focus: "Standard typography hierarchy and clean bullet achievements",
      avoid: ["Sidebars", "Color highlights", "Visual rating grids"]
    },
    psychology: {
      coreTraits: ["Efficiency", "Directness", "Technical competence", "Minimalism"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Start bullet points with strong action verbs. Quantify achievements (e.g. 'improved performance by 15%'). Use clean, direct language.",
      rewriteStyle: "Concise, result-oriented, technical"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.4,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['summary', 'experience', 'projects', 'education', 'skills']
      },
      overrides: {
        '--font-family-primary': '"Inter", sans-serif',
        '--spacing-margin': '24px'
      }
    }
  },
  styleOverrides: {
    '--font-size-display': '24pt',
    '--weight-display': '700',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.06em',
    '--heading-weight': '700',
    '--border-thickness-heading': '1.5px',
    '--bullet-style': 'disc',
    '--spacing-section-mb': '20px',
    '--spacing-item-mb': '10px',
    '--spacing-bullet-gap': '4px',
    '--color-text-main': '#2D3748',
    '--color-text-light': '#718096'
  }
};
export default cleanMinimalATS;
